export default {"src":"/_next/static/media/RKDA.b7fa92da.svg","height":18,"width":18};